export default {
  // ultra hero
  title: "font-body text-[clamp(44px,10vw,52px)] sm:text-[clamp(56px,8vw,64px)] md:text-[clamp(68px,7vw,76px)] lg:text-[clamp(84px,6vw,92px)] xl:text-[clamp(96px,5vw,104px)] 2xl:text-[112px] leading-[0.88] tracking-[-0.055em] font-black text-text text-balance",

  // hero heading
  h1: "font-body text-[clamp(36px,8vw,42px)] sm:text-[clamp(46px,7vw,52px)] md:text-[clamp(56px,6vw,60px)] lg:text-[clamp(64px,5vw,72px)] xl:text-[clamp(72px,4vw,80px)] 2xl:text-[88px] leading-[0.9] tracking-[-0.05em] font-black text-text text-balance",

  // section heading
  h2: "font-body text-[clamp(26px,6vw,30px)] sm:text-[clamp(32px,5vw,36px)] md:text-[clamp(38px,4vw,42px)] lg:text-[clamp(44px,3vw,48px)] xl:text-[clamp(52px,2.5vw,56px)] 2xl:text-[60px] leading-[0.95] tracking-[-0.04em] font-extrabold text-text text-balance",

  // subsection heading
  h3: "font-body text-[clamp(20px,4vw,24px)] sm:text-[clamp(24px,3vw,28px)] md:text-[clamp(28px,2.5vw,30px)] lg:text-[clamp(32px,2vw,34px)] xl:text-[clamp(36px,1.8vw,38px)] 2xl:text-[42px] leading-[1] tracking-[-0.03em] font-bold text-text text-balance",

  // small heading
  h4: "font-body text-[clamp(18px,2.5vw,20px)] sm:text-[clamp(19px,2vw,21px)] md:text-[clamp(20px,1.8vw,22px)] lg:text-[clamp(22px,1.5vw,24px)] xl:text-[clamp(24px,1.2vw,26px)] 2xl:text-[28px] leading-[1.08] tracking-[-0.02em] font-bold text-text text-balance",

  // light-weight h4 — same size as h4 but normal weight
  h4_light: "font-body text-[clamp(18px,2.5vw,20px)] md:text-[clamp(20px,1.8vw,22px)] lg:text-[clamp(22px,1.5vw,24px)] leading-[1.3] tracking-[-0.01em] font-normal text-text",

  // card-title heading
  h5: "font-body text-[17px] md:text-[18px] lg:text-[20px] leading-tight tracking-[-0.01em] font-bold text-text",

  // card subtitle / small title
  h6: "font-body text-[15px] md:text-[16px] lg:text-[17px] leading-tight tracking-[-0.01em] font-semibold text-text",

  // body2 — slightly smaller body
  body2: "text-[14px] md:text-[15px] lg:text-[16px] text-text leading-normal font-normal tracking-[-0.01em]",

  // body2 dim
  body2_dim: "text-[14px] md:text-[15px] lg:text-[16px] text-text_secondary leading-normal font-normal tracking-[-0.01em]",

  // body2 accent
  body2_accent: "text-[14px] md:text-[15px] lg:text-[16px] text-text leading-normal font-semibold tracking-[-0.01em]",

  // 20px 400
  body1: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-normal tracking-[-0.02em]",

  // 20px 400 gray
  body1_dim: "text-[16px] md:text-[17px] lg:text-[20px] text-text_secondary leading-normal font-normal tracking-[-0.02em]",

  // 20px 500
  body1_medium: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-semibold tracking-[-0.02em]",

  // 20px 700
  body1_accent: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-bold tracking-[-0.02em]",

  // 16px 400 — defaults to theme text so it's readable on light + dark.
  txt: "text-[15px] md:text-[16px] text-text leading-tight font-normal",

  // 16px 600
  txt_accent: "text-[15px] md:text-[16px] text-text leading-tight font-semibold",

  // 16px 400 dim
  txt_dim: "text-[15px] md:text-[16px] text-text_secondary leading-tight font-normal",

  // 14px 400
  txt1: "text-[14px] text-text leading-tight font-normal",

  // 14px 600
  txt1_accent: "text-[14px] text-text leading-tight font-semibold",

  // 14px 400 dim
  txt1_dim: "text-[14px] text-text_secondary leading-tight font-normal",

  // 12px 400
  txt2: "text-[12px] text-text leading-tight font-normal",

  // 12px 600
  txt2_accent: "text-[12px] text-text leading-tight font-semibold",

  // 12px 400 dim
  txt2_dim: "text-[12px] text-text_secondary leading-tight font-normal",

  // Small uppercase label (used on usage / quota cards)
  label_upper_dim: "text-[11px] uppercase tracking-wider font-medium text-text_secondary mt-0 mb-1",

  // 14px 400
  label: "text-[14px] text-text leading-tight font-normal mt-0 mb-1.5",

  // 14px 600 text color is defined per case 
  label_accent: "text-[14px] text-text leading-tight font-semibold mt-0 mb-1.5",

  // 14px 400 text color is defined per case 
  label_dim: "text-[14px] text-text_secondary leading-tight font-normal mt-0 mb-1.5",

  // 14px 400
  footer_item: "text-sm text-neutral_2 hover:text-white whitespace-nowrap transition-colors my-0",

  footer_group_label: "text-[10px] lg:text-[12px] font-medium uppercase tracking-wide md:tracking-widest text-neutral_1 my-0",

  // 17px 400 gray / primary
  breadcrumbs: "text-[16px] lg:text-[17px] leading-tight font-normal text-text_secondary hover:text-primary my-0",

  // error
  error: "text-[14px] text-red-500 leading-tight font-normal",
}
